import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

function eventNode(id: NodeDefinition["id"], next: readonly string[], x: number, y: number): NodeDefinition {
  return node(id, { kind: "event", next, x, y });
}

// 第7期は、旧棟の局所的な通路を進む迷宮。中央だけが一度、左右の区画へ抜けられる。
export const MAP_NODES_LABYRINTH: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["g1"], x: 2, y: 0 }),
  g1: caseNode("g1", ["g2"], 2, 1),
  g2: caseNode("g2", ["rest-g-open"], 2, 2),
  "rest-g-open": restNode("rest-g-open", ["g-l", "g-c", "g-r"], 2, 3),

  "g-l": caseNode("g-l", ["event-g-l"], 0, 4),
  "g-c": caseNode("g-c", ["g-cl", "g-cr"], 2, 5),
  "g-r": caseNode("g-r", ["g-r2"], 4, 4),
  "event-g-l": eventNode("event-g-l", ["g-l2"], 0, 5),
  "g-l2": caseNode("g-l2", ["g-l3"], 0, 6),
  "g-cl": caseNode("g-cl", ["g-l3"], 1, 6),
  "g-cr": caseNode("g-cr", ["g-r3"], 3, 7),
  "g-r2": caseNode("g-r2", ["event-g-r"], 4, 5),
  "event-g-r": eventNode("event-g-r", ["g-r3"], 4, 6),
  "g-l3": caseNode("g-l3", ["rest-g-left", "g-xfer"], 1, 8),
  "g-xfer": caseNode("g-xfer", ["g-r4"], 2, 9),
  "g-r3": caseNode("g-r3", ["g-r4", "g-r-detour"], 4, 8),
  "g-r-detour": caseNode("g-r-detour", ["rest-g-right"], 4, 9),
  "g-r4": caseNode("g-r4", ["rest-g-right"], 3, 10),
  "rest-g-left": restNode("rest-g-left", ["g-pre-l"], 1, 10),
  "rest-g-right": restNode("rest-g-right", ["g-pre-r"], 3, 11),
  "g-pre-l": caseNode("g-pre-l", ["rest-g-pre"], 1, 12),
  "g-pre-r": caseNode("g-pre-r", ["rest-g-pre"], 3, 13),
  "rest-g-pre": restNode("rest-g-pre", ["boss"], 2, 14),
  boss: node("boss", { kind: "case", caseId: "labyrinth-boss", next: [], x: 2, y: 15 }),
};
